interface rawLayouts {
    isOneColumn?: boolean;
    isTwoColumns?: boolean;
    isThreeColumns?: boolean;
    isFourColumns?: boolean;
    isFullWidth?: boolean;
}

export type Layout = 'oneColumn' | 'twoColumns' | 'threeColumns' | 'fourColumns' | 'fullWidth';

export default ({
    isTwoColumns = false,
    isThreeColumns = false,
    isFourColumns = false,
    isOneColumn = false,
    isFullWidth = false
}: rawLayouts): Layout => {
    if (isFullWidth) {
        return 'fullWidth';
    }
    if (isOneColumn) {
        return 'oneColumn';
    }
    if (isTwoColumns) {
        return 'twoColumns';
    }
    if (isThreeColumns) {
        return 'threeColumns';
    }
    if (isFourColumns) {
        return 'fourColumns';
    }
    return 'oneColumn';
};
